<h2>Скопируйте ссылку в буфер обмена</h2>
<input matInput readonly name="link" [value]="link">
